{
  "name": "@stair-craft/source",
  "version": "1.0.0",
  "license": "MIT",
  "type": "module",
  "packageManager": "pnpm@10.33.0",
  "engines": {
    "node": "^20.19.0 || ^22.13.0 || >=24.0.0",
    "pnpm": ">=10.0.0"
  },
  "scripts": {
    "start": "nx serve configurator-com",
    "build": "nx build configurator-com",
    "build:prod": "nx build configurator-com --configuration=production",
    "build:all": "nx run-many -t build -p configurator-com,configurator-by,configurator-ru --configuration=production",
    "test": "nx run-many --target=test --all",
    "test:configurator": "nx test configurator-com",
    "lint": "nx run-many --target=lint --all",
    "lint:fix": "nx run-many --target=lint --all --fix",
    "e2e": "nx e2e configurator-e2e",
    "format": "prettier --write \"apps/**/*.{ts,html,scss}\" \"libs/**/*.{ts,html,scss}\"",
    "format:check": "prettier --check \"apps/**/*.{ts,html,scss}\" \"libs/**/*.{ts,html,scss}\"",
    "build:geometry-engine": "nx build geometry-engine",
    "build:renderer-3d": "nx build renderer-3d",
    "build:ui-configurator": "nx build ui-configurator",
    "serve:ssr": "node dist/apps/configurator-com/server/server.mjs",
    "graph": "nx graph",
    "serve:ru": "nx serve configurator-com --configuration=ru",
    "serve:en": "nx serve configurator-com --configuration=en",
    "preinstall": "npx only-allow pnpm",
    "lint:styles": "stylelint \"apps/**/*.scss\" \"libs/**/*.scss\"",
    "lint:styles:fix": "stylelint \"apps/**/*.scss\" \"libs/**/*.scss\" --fix",
    "test:styles-rule": "node tools/stylelint-rules/no-hardcoded-design-tokens.spec.cjs",
    "task:new": "node tools/task-new.mjs",
    "task:move": "node tools/board.mjs move",
    "check:board": "node tools/check-board.mjs",
    "check:test-targets": "node tools/check-test-targets.mjs",
    "check:docs": "node tools/check-doc-paths.mjs",
    "check:specs": "node tools/check-specs.mjs",
    "check:dupes": "node tools/check-dupes.mjs",
    "check:layers": "node tools/check-lib-layers.mjs",
    "check:styles": "node tools/check-styles.mjs",
    "check:schema": "node tools/check-schema-drift.mjs",
    "check:all": "for c in check-doc-paths check-specs check-test-targets check-file-size check-dupes check-styles check-glossary check-lib-layers check-reuse check-schema-drift check-states check-state-next check-turn-map check-archive-age check-profile-drift check-hook-scope check-push-gate check-pipeline-triggers; do node tools/$c.mjs; s=$?; [ $s -eq 0 ] || [ $s -eq 7 ] || exit $s; done",
    "proto:generate": "nx codegen common-proto"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.2.5",
    "@angular/common": "22.2.4",
    "@angular/compiler": "22.2.4",
    "@angular/core": "22.2.4",
    "@angular/forms": "22.2.4",
    "@angular/localize": "22.2.4",
    "@angular/material": "22.2.5",
    "@angular/platform-browser": "22.2.4",
    "@angular/platform-server": "22.2.4",
    "@angular/router": "22.2.4",
    "@angular/ssr": "22.2.5",
    "@aws-sdk/client-s3": "3.1160.0",
    "@bufbuild/protobuf": "2.16.0",
    "@connectrpc/connect": "2.3.0",
    "@connectrpc/connect-express": "2.3.0",
    "@connectrpc/connect-node": "2.3.0",
    "@connectrpc/connect-web": "2.3.0",
    "@floating-ui/dom": "1.8.0",
    "@nestjs/common": "12.3.2",
    "@nestjs/core": "12.3.2",
    "@nestjs/platform-express": "12.3.2",
    "@prisma/adapter-pg": "7.10.1",
    "@prisma/client": "7.10.1",
    "@rt-tools/auth-angular": "0.1.1",
    "@rt-tools/auth-contract": "0.1.0",
    "@rt-tools/auth-server": "0.2.3",
    "@rt-tools/cms-angular": "0.1.1",
    "@rt-tools/cms-contract": "0.1.0",
    "@rt-tools/cms-server": "0.1.1",
    "@rt-tools/core": "0.5.1",
    "@rt-tools/store": "0.3.4",
    "@rt-tools/ui-kit-v2": "0.39.0",
    "@rt-tools/utils": "0.4.1",
    "cors": "2.8.6",
    "dompurify": "3.4.17",
    "express": "5.3.0",
    "jose": "6.2.14",
    "ngx-image-cropper": "9.1.7",
    "pg": "8.23.1",
    "quill": "2.0.3",
    "reflect-metadata": "0.2.2",
    "rxjs": "7.8.2",
    "sharp": "0.35.5",
    "three": "0.187.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.9.2",
    "@angular-devkit/core": "22.2.5",
    "@angular-devkit/schematics": "22.2.5",
    "@angular/build": "22.2.5",
    "@angular/cli": "22.2.5",
    "@angular/compiler-cli": "22.2.4",
    "@angular/language-service": "22.2.4",
    "@bufbuild/buf": "1.75.0",
    "@bufbuild/protoc-gen-es": "2.16.0",
    "@cloudflare/workers-types": "5.20261030.1",
    "@commitlint/cli": "21.2.4",
    "@commitlint/config-angular": "21.2.4",
    "@eslint/js": "10.0.1",
    "@nestjs/schematics": "12.0.12",
    "@nestjs/testing": "12.3.2",
    "@nx/angular": "24.0.2",
    "@nx/devkit": "24.0.2",
    "@nx/eslint": "24.0.2",
    "@nx/eslint-plugin": "24.0.2",
    "@nx/jest": "24.0.2",
    "@nx/js": "24.0.2",
    "@nx/nest": "24.0.2",
    "@nx/node": "24.0.2",
    "@nx/playwright": "24.0.2",
    "@nx/web": "24.0.2",
    "@nx/webpack": "24.0.2",
    "@nx/workspace": "24.0.2",
    "@oxc-project/runtime": "0.156.0",
    "@playwright/test": "1.64.1",
    "@rt-tools/agent-kit": "0.33.1",
    "@schematics/angular": "22.2.5",
    "@swc-node/register": "1.12.1",
    "@swc/core": "1.16.20",
    "@swc/helpers": "0.5.23",
    "@trivago/prettier-plugin-sort-imports": "6.0.2",
    "@types/cors": "2.8.19",
    "@types/express": "5.0.6",
    "@types/jest": "30.0.0",
    "@types/node": "26.6.6",
    "@types/pg": "8.23.1",
    "@types/three": "0.187.0",
    "@typescript-eslint/rule-tester": "8.72.1",
    "@typescript-eslint/utils": "8.72.1",
    "angular-eslint": "22.6.0",
    "autoprefixer": "10.6.2",
    "concurrently": "10.0.6",
    "dotenv": "18.0.9",
    "eslint": "10.13.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-playwright": "2.12.1",
    "eslint-plugin-prettier": "5.5.7",
    "eslint-plugin-sonarjs": "4.2.2",
    "jest": "30.5.2",
    "jest-environment-node": "30.5.2",
    "jest-util": "30.5.1",
    "jsdom": "30.1.3",
    "jsonc-eslint-parser": "3.3.0",
    "ng-packagr": "22.2.5",
    "nx": "24.0.2",
    "onchange": "7.1.0",
    "postcss": "8.5.32",
    "postcss-url": "10.1.4",
    "postcss-value-parser": "4.2.0",
    "prettier": "3.9.10",
    "prettier-plugin-organize-attributes": "1.0.0",
    "prisma": "7.10.0",
    "stylelint": "17.16.0",
    "stylelint-config-standard-scss": "17.0.0",
    "stylelint-prettier": "5.0.3",
    "ts-jest": "29.4.15",
    "ts-node": "10.9.2",
    "tslib": "2.8.1",
    "typescript": "6.0.3",
    "typescript-eslint": "8.72.1",
    "vitest": "5.0.5",
    "webpack": "5.112.2",
    "webpack-cli": "7.2.3",
    "webpack-dev-server": "6.1.0"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "@parcel/watcher",
      "@swc/core",
      "esbuild",
      "less",
      "lmdb",
      "msgpackr-extract",
      "nx",
      "unrs-resolver"
    ],
    "overrides": {
      "webpack": "5.111.1",
      "@babel/core@>=7.0.0 <7.29.6": "7.29.6",
      "@babel/plugin-transform-modules-systemjs@>=7.12.0 <7.29.4": "7.29.4",
      "axios@>=1.0.0 <1.20.0": "1.20.0",
      "body-parser@>=2.0.0 <2.3.0": "2.3.0",
      "brace-expansion@>=1.0.0 <1.1.21": "1.1.21",
      "brace-expansion@>=2.0.0 <2.1.7": "2.1.7",
      "brace-expansion@>=5.0.0 <5.0.12": "5.0.12",
      "deepmerge-ts@>=7.0.0 <8.0.0": "8.0.0",
      "esbuild@>=0.27.3 <0.28.1": "0.28.1",
      "fast-uri@>=3.0.0 <3.1.8": "3.1.8",
      "form-data@>=4.0.0 <4.0.6": "4.0.6",
      "hono@>=4.0.0 <4.12.25": "4.12.25",
      "http-proxy-middleware@>=0.16.0 <2.0.10": "2.0.10",
      "http-proxy-middleware@>=3.0.0 <3.0.7": "3.0.7",
      "immutable@>=5.0.0 <5.1.8": "5.1.8",
      "ip-address@>=10.0.0 <10.1.1": "10.1.1",
      "js-yaml@>=3.0.0 <3.15.2": "3.15.2",
      "js-yaml@>=4.0.0 <4.3.2": "4.3.2",
      "launch-editor@>=2.0.0 <2.14.1": "2.14.1",
      "minimatch@>=3.0.0 <3.1.4": "3.1.4",
      "mysql2@>=3.0.0 <3.23.1": "3.23.1",
      "piscina@>=5.0.0-alpha.0 <5.2.0": "5.2.0",
      "postcss-selector-parser@>=7.0.0 <7.1.3": "7.1.3",
      "qs@>=6.0.0 <6.16.0": "6.16.0",
      "shell-quote@>=1.1.0 <1.8.4": "1.8.4",
      "smol-toml@>=1.0.0 <1.7.1": "1.7.1",
      "svgo@>=4.0.0 <4.1.0": "4.1.0",
      "tar@>=7.0.0 <7.5.16": "7.5.16",
      "tmp@>=0.0.0 <0.2.7": "0.2.7",
      "undici@>=7.0.0 <7.28.0": "7.28.0",
      "uuid@>=11.0.0 <11.1.1": "11.1.1",
      "webpack-dev-middleware@>=8.0.0 <8.3.0": "8.3.0",
      "ws@>=8.0.0 <8.21.0": "8.21.0"
    }
  }
}
